/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import {
  currentModelId,
  selectStructuralResponseErrors,
  selectStructuralResponseReturnPeriodsById,
  selectStructuralResponseLocations,
  selectStructuralResponseIsStory,
  selectUploadedGroundMotionReturnPeriods,
  selectUploadedGroundMotionErrors,
  selectModeShapeFloors,
  selectModeShapeModes,
  selectUploadedModeShapeErrors,
} from '#selectors/entities/models.js';
import {
  selectComponentByUuid,
  selectEdpKeyByComponentUuid,
} from '#selectors/entities/components.js';

const buildValidationContext = state => {
  const modelId = currentModelId(state);
  return {
    getComponentByUuid: uuid => selectComponentByUuid(state, { uuid }),
    getEdpKeyByComponentUuid: uuid => selectEdpKeyByComponentUuid(state, { uuid }),
    getCurrentModelId: () => modelId,
    getStructuralResponseErrors: responseId =>
      selectStructuralResponseErrors(state, { modelId, responseId }),
    getStructuralResponseReturnPeriodsById: responseId =>
      selectStructuralResponseReturnPeriodsById(state, { modelId, responseId }),
    getStructuralResponseLocations: responseId =>
      selectStructuralResponseLocations(state, { modelId, responseId }),
    getStructuralResponseIsStory: responseId =>
      selectStructuralResponseIsStory(state, { modelId, responseId }),
    getUploadedGroundMotionReturnPeriods: () =>
      selectUploadedGroundMotionReturnPeriods(state, { modelId }),
    getUploadedGroundMotionErrors: () => selectUploadedGroundMotionErrors(state, { modelId }),
    getModeShapeFloors: () => selectModeShapeFloors(state, { modelId, direction: 1 }),
    getModeShapeModes: () => selectModeShapeModes(state, { modelId, direction: 1 }),
    getUploadedModeShapeErrors: () => selectUploadedModeShapeErrors(state, { modelId }),
  };
};

export default buildValidationContext;
